import axios from "axios";
import jwt_decode from "jwt-decode";
import { userLogout } from "../features/actions/authAsyncAction";
import { toast } from "react-toastify";
import store from "../app/store";

const PRODUCTION_URL = "	https://netfee.top/api/v1/";
const DEV_URL = "http://localhost:9099/api/v1/";

const DEFAULT_URL =
  process.env.NODE_ENV === "production" ? PRODUCTION_URL : DEV_URL;

const getBaseURL = () => {
  const state = store.getState();
  const server = state.persistedReducer.auth?.userData?.bpSettings?.server;

  return server ? `${server}/api/v1/` : DEFAULT_URL;
};

export const publicRequest = axios.create({
  baseURL: DEFAULT_URL,
});

const apiLink = axios.create({
  baseURL: getBaseURL(),
});

apiLink.interceptors.request.use(
  async (config) => {
    config.baseURL = getBaseURL();

    const TOKEN = JSON.parse(localStorage.getItem("netFeeToken"));

    if (!TOKEN) {
      store.dispatch(userLogout());
      localStorage.removeItem("netFeeToken");
      return Promise.reject(new Error("No token found"));
    }

    const currentDate = new Date();
    const decodedToken = jwt_decode(TOKEN);

    if (decodedToken.exp * 1000 < currentDate.getTime()) {
      store.dispatch(userLogout());
      return Promise.reject(new Error("Token expired"));
    }

    config.headers["authorization"] = "Bearer " + TOKEN;
    return config;
  },
  (error) => Promise.reject(error),
);

apiLink.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      toast.error(error.response?.data?.message);
      setTimeout(() => {
        store.dispatch(userLogout());
      }, 500);
    }
    return Promise.reject((error.response && error.response?.data) || error);
  },
);

export default apiLink;
